import Link from 'next/link'
import dynamic from 'next/dynamic';
import {getAnchorIdFromEntity} from '../../adapters/helpers/Anchor';
import {SeriesTabsConstants} from '../../adapters/helpers/Constants';
import C from 'classnames';
const Icon = dynamic(() => import('../Icon/Icon'));
import PropTypes from 'prop-types';
import React, {Suspense, useCallback, useRef, useState} from 'react';
import {CSSTransition} from 'react-transition-group';
import {stripHtml} from '../../adapters/helpers/Utils';
import {Constants} from '../../adapters/helpers/Constants';
const Meta = dynamic(() => import('../../components/Meta/Meta'));
import Loader from '../../adapters/helpers/Loader';
import LazyLoad from 'react-lazy-load';
import DOMPurify from 'isomorphic-dompurify';

export default function SeriesTabs({ items, collection, selectedItem, selectedSeriesId, selectedIndex, basePath }) {
    const [navCollapsed, setNavCollapsed] = useState(true);
    const [navHeight, setNavHeight] = useState(0);
    const navList = useRef(null);

    const seriesMetaData = selectedItem?.fields?.metadata?.fields;
    const metaData = collection?.metadata?.fields;

    const handleNavToggle = useCallback(
        () => { setNavCollapsed(prevState => !prevState); },
        [],
    );

    const calculateHeight = useCallback(
        () => {
            if (navList.current) {
                setNavHeight(navList.current.scrollHeight);
            }
        },
        [],
    );

    return (items && items.length > 0) ? (
        <LazyLoad offset={50} unmountIfInvisible={true}>
       <Suspense fallback={<Loader/>}>
        {selectedSeriesId  && seriesMetaData ? <Meta metadata={selectedItem?.fields?.metadata?.fields} pagePath={`${basePath}${Constants.pathDelimiter}${selectedItem.anchorId}`}/> : <Meta metadata={metaData} pagePath={collection?.slug?.fields?.slug}/> }
        <CSSTransition in={!navCollapsed} timeout={800} onEntering={calculateHeight} onExit={calculateHeight}>
            <nav className='ob-series-selector__nav'>
                <div className='ob-series-selector__nav-toggle' role={SeriesTabsConstants.buttonRole} tabIndex='0' onKeyDown={handleNavToggle} onKeyPress={handleNavToggle} aria-expanded={!navCollapsed}  aria-hidden={false} onClick={handleNavToggle}>
                    <div className='ob-series-selector__nav-link-name'
                        dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(selectedItem.fields.shortTitle)}}>
                    </div>

                            {!!selectedItem.fields.startingAtLabel && (
                                <div className='ob-series-selector__nav-link-price'>
                                    {selectedItem.fields.startingAtLabel.fields.text}
                                </div>
                            )}

                            <Icon className='ob-series-selector__nav-chevron' name={SeriesTabsConstants.chevronDown} size={1.6} />
                        </div>

                        <div className='ob-series-selector__nav-collapsible' style={{ height: navHeight }}>
                            <ul className='ob-series-selector__nav-list' ref={navList}>
                                {items.map((item, i) => (
                                    <li key={i}
                                        className={C('ob-series-selector__nav-item', {
                                            ['ob-series-selector__nav-item--active']: i === selectedIndex
                                        })}
                                        aria-hidden={false}
                                        
                                    >
                                    <Link href={`${basePath}${Constants.pathDelimiter}${getAnchorIdFromEntity(item)}`}
                                            className='ob-series-selector__nav-link event_button_click'
                                            data-action-detail={stripHtml(item.fields.shortTitle)}>
                                        <div>
                                                    {
                                                        i == selectedIndex ? 
                                                        <div className='ob-series-selector__nav-link-name'
                                                            aria-current={SeriesTabsConstants.page}
                                                            dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(item.fields.shortTitle) }}>
                                                        </div>
                                                    :
                                                        <div className='ob-series-selector__nav-link-name'
                                                        dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(item.fields.shortTitle) }}>
                                                        </div>
                                                    }

                                            {!!item.fields.startingAtLabel && (
                                                <div className='ob-series-selector__nav-link-price'>
                                                    {item.fields.startingAtLabel.fields.text}
                                                </div>
                                            )}
                                </div>
                            </Link>
                            </li>
                        )
                        
                        )}
                    </ul>
                </div>
            </nav>
        </CSSTransition>
       </Suspense>
       </LazyLoad>
    ) : null;
}

SeriesTabs.propTypes = {
    items: PropTypes.any,
    selectedItem: PropTypes.any,
    selectedIndex: PropTypes.any,
    basePath: PropTypes.any
}
